export default "__VITE_ASSET__CveJf906__"